<template>
  <div
    :class="toggleDivClassname"
    class="offside-js--init offside-js--interact"
  >
    <kcs-header :is-home="isHome" @toggle="toggleSidemenu" />
    <div
      id="all-content-container"
      :class="{ top: isHome }"
      class="offside-sliding-element"
    >
      <kcs-ads-header v-if="!isHome && !$device.isMobile" />
      <kcs-breadcrumbs :list="list" v-if="!isHome && !$device.isMobile" />
      <nuxt />
      <kcs-ads-history-top />
      <kcs-facility-view-history
        :is-btn="true"
        :is-small-gallery="true"
        v-if="isHome || isSearchPage || isFacilityPage || isFeaturePage"
        title="最近チェックした施設"
        summary=""
        div-class="history-facility"
        h2-class="page-title blue"
      />
      <kcs-footer />
    </div>

    <kcs-fixed-footer
      v-if="$device.isMobile && isFacilityPage && !dataSidemenu"
      name="施設へ問い合わせる"
    />
    <kcs-fixed-search-footer
      v-if="$device.isMobile && isSearchPage && !dataSidemenu"
      name="施設を絞り込む"
    />

    <nav
      id="offcanvas-menu"
      :class="toggleClassname"
      class="offside offside--left"
    >
      <kcs-search-panel @toggle="toggleSidemenu" />
    </nav>
    <kcs-search-filter v-if="isSearchPage" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import KcsHeader from '@/components/organisms/kcs-header.vue'
import KcsBreadcrumbs from '@/components/atoms/kcs-breadcrumbs.vue'
import KcsFixedFooter from '@/components/atoms/kcs-fixed-footer.vue'
import KcsFixedSearchFooter from '@/components/atoms/kcs-fixed-search-footer.vue'
import KcsFooter from '@/components/organisms/kcs-footer.vue'
import KcsSearchPanel from '@/components/organisms/kcs-search-panel.vue'
import KcsSearchFilter from '@/components/organisms/kcs-search-filter.vue'
import KcsAdsHistoryTop from '@/components/molecules/kcs-ads-history-top.vue'
import KcsAdsHeader from '@/components/molecules/kcs-ads-header.vue'
import KcsFacilityViewHistory from '@/components/organisms/kcs-facility-view-history.vue'
export default {
  components: {
    KcsHeader,
    KcsBreadcrumbs,
    KcsFixedFooter,
    KcsFixedSearchFooter,
    KcsFooter,
    KcsSearchPanel,
    KcsSearchFilter,
    KcsAdsHistoryTop,
    KcsAdsHeader,
    KcsFacilityViewHistory
  },
  head() {
    return {
      meta: [
        {
          hid: 'og-url',
          property: 'og:url',
          content: process.env.SITE_URL + encodeURI(this.$route.path)
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: this.breadcrumbJsonLd
        }
      ]
    }
  },
  data() {
    return {
      dataSidemenu: false
    }
  },
  computed: {
    ...mapGetters({
      list: 'breadcrumb/list',
      breadcrumbJsonLd: 'breadcrumb/jsonld'
    }),
    toggleDivClassname() {
      if (this.dataSidemenu) {
        return ['offside-js--is-open', 'offside-js--is-left']
      } else {
        return []
      }
    },
    toggleClassname() {
      if (this.dataSidemenu) {
        return ['is-open']
      } else {
        return []
      }
    },
    isHome() {
      return this.$route.path === '/'
    },
    isSearchPage() {
      return /^\/(s|sm|station)\//.test(this.$route.path)
    },
    isFacilityPage() {
      return /^\/p\//.test(this.$route.path)
    },
    isFeaturePage() {
      return /^\/f\//.test(this.$route.path)
    }
  },
  watch: {
    /* istanbul ignore next */
    $route(to, from) {
      this.dataSidemenu = false
    }
  },
  methods: {
    // サイドメニューの開閉を切り替える
    toggleSidemenu() {
      this.dataSidemenu = !this.dataSidemenu
    }
  }
}
</script>
